import { render, staticRenderFns } from "./contact-section.vue?vue&type=template&id=0f51fcaa&scoped=true"
import script from "./contact-section.vue?vue&type=script&lang=js"
export * from "./contact-section.vue?vue&type=script&lang=js"
import style0 from "./contact-section.vue?vue&type=style&index=0&id=0f51fcaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f51fcaa",
  null
  
)

export default component.exports